/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon24Solid = forwardRef('AttachLinkOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.698 1.616A1.25 1.25 0 1 0 1.93 3.384l19 19a1.25 1.25 0 0 0 1.768-1.768L19.9 17.82A6.5 6.5 0 0 0 17 5.5h-2.25a1.25 1.25 0 1 0 0 2.5H17a4 4 0 0 1 .965 7.883l-2.633-2.633h.918a1.25 1.25 0 1 0 0-2.5h-3.418L9.9 7.818A1.25 1.25 0 0 0 9.25 5.5H7.582L3.698 1.616Z" }),
        React.createElement("path", { d: "M2.876 6.976A6.5 6.5 0 0 0 7 18.5h2.25a1.25 1.25 0 1 0 0-2.5H7a4 4 0 0 1-2.343-7.242L2.876 6.976Z" }),
        React.createElement("path", { d: "M6.689 10.79A1.25 1.25 0 0 0 7 13.25h2.15l-2.461-2.46Z" })));
});
